import { Component } from '@angular/core';

import {
  LayoutContentComponent,
  LayoutFullPanelComponent,
  LayoutHeaderComponent,
  LayoutHeaderCtasComponent,
  LayoutHeaderDefaultComponent,
  LayoutHeaderLogoComponent,
  LayoutNavComponent,
  LayoutNotFoundComponent,
  LayoutPageComponent,
  LayoutPanelComponent,
  LayoutSideComponent,
  LayoutSideContentComponent,
  LayoutSideCtaComponent,
  LayoutTitleComponent,
  LayoutWithPanelComponent,
} from '@camelot/ui';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [
        LayoutContentComponent,
        LayoutFullPanelComponent,
        LayoutHeaderComponent,
        LayoutHeaderCtasComponent,
        LayoutHeaderDefaultComponent,
        LayoutHeaderLogoComponent,
        LayoutNavComponent,
        LayoutNotFoundComponent,
        LayoutPageComponent,
        LayoutPanelComponent,
        LayoutSideComponent,
        LayoutSideContentComponent,
        LayoutSideCtaComponent,
        LayoutTitleComponent,
        LayoutWithPanelComponent,
        TestIdDirective,
    ],
    template: `
    <cam-layout-page camTestId="cam-layout-page">
      <cam-layout-header camTestId="cam-layout-header">
        <cam-layout-title camTestId="cam-layout-title">Page title</cam-layout-title>
      </cam-layout-header>
      <cam-layout-nav camTestId="cam-layout-nav">nav</cam-layout-nav>
      <cam-layout-content camTestId="cam-layout-content">content</cam-layout-content>
    </cam-layout-page>
    <cam-layout-header-default camTestId="cam-layout-header-default" />
    <cam-layout-header-logo camTestId="cam-layout-header-logo" />
    <cam-layout-header-ctas camTestId="cam-layout-header-ctas" title="Ctas title" />
    <cam-layout-side camTestId="cam-layout-side">
      <cam-layout-side-content camTestId="cam-layout-side-content">side content</cam-layout-side-content>
      <cam-layout-side-cta camTestId="cam-layout-side-cta">side cta</cam-layout-side-cta>
    </cam-layout-side>
    <cam-layout-panel camTestId="cam-layout-panel">panel</cam-layout-panel>
    <cam-layout-full-panel camTestId="cam-layout-full-panel" title="Full panel">full panel</cam-layout-full-panel>
    <cam-layout-with-panel camTestId="cam-layout-with-panel" [open]="false">with panel</cam-layout-with-panel>
    <cam-layout-not-found camTestId="cam-layout-not-found" />
  `
})
export class UiLayoutCase {}
